import React from 'react';
import './LinkIcon.scss';

export default function LinkIcon({ width, height, fill, additionalStyles }) {
  const style = {
    width: `${width}px`,
    height: `${height}px`,
    ...additionalStyles,
  };
  return (
    <svg
      style={style}
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="link-icon"
    >
      <path
        d="M6.55873 23C8.29384 23 9.95898 22.3109 11.1857 21.083L14.7193 17.537C15.1711 17.0851 15.1711 16.352 14.7193 15.9001C14.2674 15.4483 13.5343 15.4483 13.0824 15.9001L9.56013 19.4461C8.48471 20.5034 6.92921 20.9124 5.47307 20.5181C4.01583 20.1239 2.87829 18.9863 2.48405 17.5291C2.0898 16.073 2.49873 14.5175 3.55606 13.442L7.09077 9.90849C7.45564 9.44759 7.41836 8.78677 7.00266 8.37106C6.58696 7.95536 5.92611 7.91696 5.46524 8.28295L1.91924 11.8084C0.691329 13.0363 1.38653e-06 14.7026 1.38653e-06 16.4412C-0.00112817 18.1785 0.687945 19.8458 1.91586 21.0748C3.14377 22.305 4.80887 22.9974 6.5463 22.9997L6.55873 23Z"
        fill={fill}
      />
      <path
        d="M11.8829 1.8452L8.35744 5.39119C7.90559 5.84305 7.90559 6.57619 8.35744 7.02804C8.8093 7.4799 9.54244 7.4799 9.99429 7.02804L13.5166 3.48205C14.3051 2.65515 15.3952 2.18184 16.5383 2.16828C17.6803 2.15472 18.7806 2.60205 19.5895 3.40975C20.3983 4.21857 20.8468 5.31771 20.8332 6.46095C20.8208 7.60413 20.3463 8.69425 19.5206 9.48265L15.9858 13.0194C15.7283 13.225 15.569 13.53 15.5509 13.8598C15.5317 14.1885 15.6549 14.5105 15.8876 14.7432C16.1203 14.977 16.4422 15.099 16.7721 15.0798C17.1008 15.0618 17.4058 14.9036 17.6114 14.6449L21.1574 11.1195C22.7682 9.4544 23.3816 7.06191 22.7694 4.82737C22.1571 2.59182 20.4107 0.84528 18.1751 0.233073C15.9406 -0.379191 13.5481 0.234203 11.883 1.84505L11.8829 1.8452Z"
        fill={fill}
      />
      <path
        d="M6.31805 16.6842C6.53494 16.9011 6.82977 17.0231 7.13703 17.0231C7.44316 17.0231 7.73798 16.9011 7.95487 16.6842L16.758 7.87879C17.2098 7.4258 17.2098 6.69379 16.758 6.24194C16.3061 5.79008 15.573 5.79008 15.1211 6.24194L6.31802 15.0497C5.8673 15.5015 5.8673 16.2324 6.31802 16.6842L6.31805 16.6842Z"
        fill={fill}
      />
    </svg>
  );
}
